import NodeCache from 'node-cache';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

const cache = new NodeCache();

export function cacheOrExecute<T>(
  cacheKey: string,
  fn: () => Observable<T>,
  durationInSec = 3600,
): Observable<T> {
  const cachedResult = cache.get<T>(cacheKey);

  if (cachedResult) return of(cachedResult);
  else {
    const newObservable = fn();

    return newObservable.pipe(
      map((value) => value),
      filter(Boolean),
      map((value: T): T => {
        cache.set(cacheKey, value, durationInSec);
        return value;
      }),
    );
  }
}
